import type { StripeError } from '@stripe/stripe-js';

export const isStripeError = (err: unknown): err is StripeError => {
    return (err as StripeError | undefined)?.payment_intent !== undefined;
};
